import { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const PIN = `<svg width="34" height="44" viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg"><path d="M12 0C5.4 0 0 5.4 0 12c0 9 12 20 12 20s12-11 12-20C24 5.4 18.6 0 12 0z" fill="#1FA3E8"/><circle cx="12" cy="12" r="5" fill="#fff"/></svg>`;

export const MapaSedes = ({ sedes }) => {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (mapRef.current || !ref.current) return;
    const map = L.map(ref.current, { scrollWheelZoom: false });
    mapRef.current = map;
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap',
    }).addTo(map);
    const icon = L.divIcon({ html: PIN, className: '', iconSize: [34, 44], iconAnchor: [17, 44], popupAnchor: [0, -42] });
    const bounds = [];
    sedes.forEach((s) => {
      if (!s.lat) return;
      bounds.push([s.lat, s.lng]);
      const dirUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(s.maps)}`;
      L.marker([s.lat, s.lng], { icon }).addTo(map).bindPopup(
        `<div style="font-family:Inter,sans-serif;min-width:170px">
          <p style="font-weight:800;margin:0 0 4px">${s.nombre}</p>
          ${s.dir ? `<p style="margin:0 0 8px;color:#555;font-size:12px">${s.dir}</p>` : ''}
          <a href="${dirUrl}" target="_blank" rel="noreferrer" style="display:inline-block;background:#1FA3E8;color:#fff;font-weight:800;font-size:12px;padding:6px 12px;border-radius:999px;text-decoration:none">Cómo llegar →</a>
        </div>`
      );
    });
    if (bounds.length) map.fitBounds(bounds, { padding: [40, 40] });
    return () => { map.remove(); mapRef.current = null; };
  }, [sedes]);

  return <div ref={ref} className="w-full h-[420px] rounded-3xl border border-white/10 overflow-hidden relative z-0" data-testid="mapa-sedes" />;
};
